import { forceInt, forceFloat } from '../functions';
import 'intl-tel-input';
import VimeoPlayer from '@vimeo/player';

import { getCurrenLocaleObj } from "../functions";

class Evc {
    constructor() {
        this.requestAction = '';
        this.requestData = {};
        this.requestMethod = 'POST';
        this.requestContentType = 'application/x-www-form-urlencoded'; // application/json, application/x-www-form-urlencoded, multipart/form-data, text/plain
    }

    creditsGet(callback = null) {
        this.requestAction = 'credits';
        this.requestMethod = 'GET';

        this.request(callback);
    }

    customerExists(callback = null) {
        this.requestAction = 'customerExists';
        this.requestMethod = 'GET';

        this.request(callback);
    }

    creditItemStatusCheck(callback, data) {
        this.requestAction = 'creditItemStatusCheck';
        this.requestMethod = 'GET';
        this.requestData = data;

        this.request(callback);
    }

    request(callback = null) {
        const currenLocaleObj = getCurrenLocaleObj();

        $.ajax({
            url: currenLocaleObj.urlPrefix + '/dashboard/winols/' + this.requestAction,
            contentType: this.requestContentType,
            type: this.requestMethod,
            data: this.requestData,
            success: function (response) {
                if (response.status === 0) {
                    if (response.error !== false) {
                        console.error('EVC API: ' + response.error);
                    }
                }

                if (callback !== null) {
                    callback(response);
                }
            },
            dataType: 'json',
        });
    }
}

$(function() {
    const $evc = $('.evc');
    if (!$evc.length) return;

    const $evcDash = $('#evc-dash'),
        $homeSectionVimeoIframe = $('#evc-section-home__vimeo-iframe'),
        $evcDashCourse = $('#evc-dash-course'),
        $videos = $('.video-trigger'),
        $evcCreditsRow = $('#evc-credits-row'),
        $customerNumberValidateRow = $('#evc-customer-number-validate-row'),
        $evcCreditItems = $('.evc-credit-item'),
        loadingImageHtml = '<img src="/resources/themes/base/production/images/ajax-loader-button.gif" alt="...">',
        loadingImageSpinnerHtml = '<img src="/resources/themes/base/production/images/ajax_loader.gif" alt="...">';;

    let evcIsFirstLoad = true;

    const evcHashCheck = function(hash) {
        let defaultSection = $evcDash.data('default-section'),
            defaultHash = '#' + defaultSection,
            customerNumber = forceInt($evcDash.data('customer-number')),
            customerNumberCheck = $evcDash.data('customer-number-check');

        if (hash === '#section-validate') {
            if (!customerNumber) {
                evcUpdateHash(defaultHash);
                hash = defaultHash;
            }
        } else if (hash === '#section-credits') {
            if (!customerNumber || customerNumberCheck !== 'Valid') {
                evcUpdateHash(defaultHash);
                hash = defaultHash;
            }
        }

        return hash;
    };

    const evcUpdateHash = function(hash, triggerChange = false) {
        history.replaceState(undefined, undefined, window.location.pathname + hash);
        if (triggerChange) {
            $(window).trigger('hashchange');
        }
    };

    const evcHashUpdated = function() {
        let hash = window.location.hash,
            defaultSection = $evcDash.data('default-section');

        if (hash === '' || hash === '#') {
            hash = '#' + defaultSection;
            evcUpdateHash(hash);
        } else {
            hash = evcHashCheck(hash);
        }

        const hashID = hash.replace('#', '#evc-'),
            $hashEl = $(hashID + '.evc-dash__section'),
            hashElDisplay = $hashEl.data('display');

        $('.evc-dash__section').css('display', 'none');
        $hashEl.css('display', hashElDisplay);

        $('.js-evc-customer-number').hide();
        if (hash === '#section-credits' || hash === '#section-validate') {
            $('.js-evc-customer-number').show();
        }

        if ($videos.length) {
            $videos.each(function() {
                const $this = $(this),
                    $iframe = $this.find('iframe');
                if ($iframe.length) {
                    const vimeoPlayer = new VimeoPlayer($iframe);
                    vimeoPlayer.pause();
                }
            });
        }

        if ($evcDashCourse.length) {
            $evcDashCourse.removeClass('evc-dash--course-small');
            if (hash === '#section-credits' || hash === '#section-validate') {
                $evcDashCourse.addClass('evc-dash--course-small');
            }
        }

        if (evcIsFirstLoad) {
            evcIsFirstLoad = false;
        } else {
            let $scrollTopEl = $('.evc-dash');
            if (hash !== '#section-home') {
                $scrollTopEl = $('#evc-dash');
            }
            $scrollTopEl.get(0).scrollIntoView({ behavior: 'smooth' });
        }
    };

    const evcUpdateTotal = function($this) {
        const quantity = forceInt($this.val()),
            $creditsQuantity = $('.js-evc-credits-quantity'),
            $creditsPriceTotal = $('.js-evc-credits-price-total'),
            $creditsDiscount = $('.js-evc-credits-discount'),
            $creditsPriceGrandTotal = $('.js-evc-credits-grand-total'),
            creditDefaultPrice = forceFloat($creditsPriceTotal.data('credits-default-price'));
        let total = creditDefaultPrice * quantity,
            price = 0,
            grandTotal = 0,
            discount = 0,
            totalText = '',
            discountText = '&nbsp;',
            grandTotalText = '';

        const evcPrice = evcPrices.find((evcPrice) => {
            return quantity === forceInt(evcPrice.Quantity);
        });

        if (evcPrice) {
            price = forceFloat(evcPrice.UnitPrice);
            grandTotal = price * quantity;
            if (grandTotal < total) {
                discount = (1 - (grandTotal / total)) * 100;
                discount = Number(discount).toFixed(2);
            }
        }

        $creditsQuantity.text(quantity);
        total = Number(total).toFixed(2);
        totalText = '$' + total;
        $creditsPriceTotal.text(totalText);

        if (discount > 0) {
            discountText = `(Bulk Discount ${discount}% OFF)`;
        }
        $creditsDiscount.html(discountText);

        grandTotal = Number(grandTotal).toFixed(2);
        grandTotalText = '$' + grandTotal;
        $creditsPriceGrandTotal.text(grandTotalText);
    };

    const evcCreditsGet = function() {
        const $evcActionCreditsBalance = $('.js-evc-act-credits-balance');
        if (window.location.hash === '#section-credits') {
            if ($evcActionCreditsBalance.length) {
                const evc = new Evc(),
                    $messages = $('.evc-dash__section__messages--section-credits');

                $messages.html('');

                evc.creditsGet(function(response) {
                    let html = '-';

                    if (response.status === 1 && response.data) {
                        html = response.data.credits;
                    } else if (response.status === 0 && response.error) {
                        $messages.html(`<div class="alert alert-danger alert-dismissible">${response.error}<button type="button" class="close alert-vip-offer-close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>`);
                    }

                    $evcActionCreditsBalance.html(html);
                });
            }
        }
    };

    const evcCustomerExists = function() {
        if (window.location.hash === '#section-validate') {
            const evc = new Evc(),
                $processing = $('.evc-customer-number-validation__processing'),
                $success = $('.evc-customer-number-validation__success'),
                $failure = $('.evc-customer-number-validation__failure'),
                $error = $('.evc-customer-number-validation__error');

            $processing.show();
            $success.hide();
            $failure.hide();
            $error.hide();
            $error.html('');

            setTimeout(function() {
                evc.customerExists(function(response) {
                    $processing.hide();
                    if (response.status === 1) {
                        $success.show();
                        $evcDash.data('customer-number-check', 'Valid');
                    } else if (response.status === 0) {
                        if (response.error) {
                            $error.show();
                            $error.html(`<div class="alert alert-danger alert-dismissible">${response.error}<button type="button" class="close alert-vip-offer-close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>`);
                        } else {
                            $evcDash.data('customer-number-check', 'Invalid');
                            $failure.show();
                        }
                    }
                });
            }, 2000);
        }
    };

    const creditItemStatusShow = function($tr, status) {
        const $statusTd = $tr.find('td.status'),
            $statusSpans = $statusTd.find('.evc-credit-status'),
            $currentStatusSpan = $statusTd.find('.evc-credit-status-' + status);

        $statusSpans.hide();
        $currentStatusSpan.show();
    };

    const creditItemStatusCheck = function($tr) {
        const evc = new Evc(),
            id = $tr.data('id'),
            $statusTd = $tr.find('td.status'),
            $loadingSpan = $statusTd.find('.evc-credit-status-Loading'),
            $statusSpans = $statusTd.find('.evc-credit-status');
        let status = $tr.data('status');

        creditItemStatusShow($tr, 'Loading');
        evc.creditItemStatusCheck(function(response) {
            if (response.status === 1) {
                if (response.data && response.data.creditItemStatus) status = response.data.creditItemStatus;
                if (status !== '') {
                    $tr.data('status', status);
                    creditItemStatusShow($tr, status);
                    if (status === 'Pending' || status === 'Processing') {
                        setTimeout(function() {
                            creditItemStatusCheck($tr);
                        }, 5000);
                    } else if (status === 'Credited' || status === 'Debited') {
                        const $evcActionCreditsBalance = $('.js-evc-act-credits-balance');
                        if ($evcActionCreditsBalance.length) {
                            $evcActionCreditsBalance.html(loadingImageHtml);
                            evcCreditsGet();
                        }
                    }
                }
            } else {
                console.error('Failed to get status for CreditItem ' + id + '');
                creditItemStatusShow($tr, status);
            }
        }, {id: id});
    };

    const messagesHtmlGenerate = function(messages, type = 'bootstrapAlert') {
        let messagesHtml = '';

        if (messages) {
            for (let n = 0, m = messages.length; n < m; n++) {
                const message = messages[n];

                if (type === 'bootstrapAlert') {
                    messagesHtml += '<div class="alert alert-' + message.type + ' alert-dismissible" role="alert">' +
                        '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
                        message.text +
                    '</div>';
                } else {
                    messagesHtml += '<div class="notification reminder-note remove ' + message.type + ' open" role="alert">' +
                        '<div class="container">' +
                            '<h4>' + message.text + '</h4>' +
                        '</div>' +
                    '</div>';
                }
            }
        }

        return messagesHtml;
    };

    evcHashUpdated();
    evcCustomerExists();
    evcCreditsGet();

    $(window).on('hashchange', function(e) {
        evcHashUpdated();
        evcCustomerExists();
        evcCreditsGet();
    });

    const $evcHasCompany = $('#RegisterForm_EvcRegisterForm_EvcAccountHasCompany'),
        $evcCompanyInfo = $('#evc-company-info');
    if ($evcHasCompany.length && $evcCompanyInfo.length) {
        $evcHasCompany.on('change', function() {
            const $this = $(this),
                val = $this.val();

            if ($this.is(':checked')) {
                $evcCompanyInfo.show();
            } else {
                $evcCompanyInfo.hide();
            }
        });

        if ($evcHasCompany.is(':checked')) {
            $evcCompanyInfo.show();
        } else {
            $evcCompanyInfo.hide();
        }
    }

    const $form = $('#RegisterForm_EvcRegisterForm'),
        $phoneField = $('#RegisterForm_EvcRegisterForm_EvcAccountPhone');
    if ($phoneField.length) {
        $phoneField.intlTelInput({
            initialCountry: 'auto',
            separateDialCode: true,
            geoIpLookup: function(callback) {
                $.get('https://ipinfo.io', function() {}, 'jsonp').always(function(resp) {
                    var countryCode = resp && resp.country ? resp.country : '';
                    callback(countryCode);
                });
            },
            utilsScript: '/resources/themes/base/thirdpartyjs/utils.js'
        });
    }

    if ($form.length) {
        $form.on('submit', function() {
            if ($phoneField.length) {
                let wholeNum = $phoneField.intlTelInput('getNumber');
                $phoneField.val(wholeNum);
            }
        });
    }

    if ($evcCreditItems.length) {
        $evcCreditItems.each(function() {
            const $tr = $(this),
                $statusTd = $tr.find('td.status'),
                id = $tr.data('id'),
                status = $tr.data('status');

            creditItemStatusShow($tr, status);

            if (status === 'Pending' || status === 'Processing') {
                setTimeout(function() {
                    creditItemStatusCheck($tr);
                }, 5000);
            }
        });
    }

    const $purchaseFormDropdown = $('.hpa-selectmenu');
    if ($purchaseFormDropdown.length) {
        $purchaseFormDropdown.hpaSelectmenu();
        $purchaseFormDropdown.on('hpaselectmenuchange', function() {
            evcUpdateTotal($(this));
        });
        $purchaseFormDropdown.trigger('hpaselectmenuchange');
    }

    const $customMapsForm = $('#CustomMapForm_EvcCustomMapForm');
    if ($customMapsForm.length) {
        const $evcCustomMapsWrapper = $('.evc-custom-maps'),
            $uploadButton = $('#evc-custom-maps__upload__button'),
            $uploadFilename = $('#evc-custom-maps__upload__filename'),
            $fileField = $('#CustomMapForm_EvcCustomMapForm_File'),
            $info = $('#evc-custom-maps__upload__info'),
            $inputsFields = $('#evc-custom-maps__upload__input-fields'),
            $notifications = $('#evc-custom-maps__notifications'),
            $uploadSection = $('.evc-custom-maps__upload-section'),
            $formSection = $('.evc-custom-maps__form-section'),
            $formSubmitButton = $('#CustomMapForm_EvcCustomMapForm_action_doSubmit'),
            $formUploading = $('#evc-custom-maps__form-section__uploading');
        let formSubmitted = false;
        if ($uploadButton.length) {
            $uploadButton.on('click', function() {
                $notifications.html('');
                $fileField.trigger('click');

                /*if (!formSubmitted && $uploadButton.hasClass('evc-custom-maps__upload__button--submit')) {
                    formSubmitted = true;
                    let customMapFileID = $uploadButton.data('file-id');
                    let description = $infoInputs.find('.custom-map-description').val();
                    const data = {
                        description: description
                    };
                    $.ajax({
                        url: '/dashboard/winols/customMapFile/?id=' + customMapFileID,
                        type: 'POST',
                        data: data,
                        dataType: 'json',
                        success: function (data) {
                            $fileField.val('');
                            $uploadFilename.text('');
                            $info.show();
                            $description.val('').hide();
                            $uploadButton.text($uploadButton.data('text-default')).removeClass('evc-custom-maps__upload__button--submit');
                            if (data.status === 1) {
                                let messagesHTML = messagesHtmlGenerate([{ type: 'success', text: 'SUBMISSION SUCCESSFUL' }], 'bootstrapAlert');
                                if (messagesHTML.length) {
                                    $notifications.html(messagesHTML);
                                }
                            }

                            if (data.error) {
                                let messagesHTML = messagesHtmlGenerate([{ type: 'danger', text: data.error }], 'bootstrapAlert');
                                if (messagesHTML.length) {
                                    $notifications.html(messagesHTML);
                                }
                            }
                        },
                        error: function () {
                            let messagesHtml = messagesHtmlGenerate([{type: 'danger', text: 'An error occured. Please reload the page.'}], 'bootstrapAlert');
                            $notifications.html(messagesHtml);
                        },
                        complete: function () {
                            formSubmitted = false;
                        }
                    });
                } else if (!$uploadButton.hasClass('evc-custom-maps__upload__button--uploading')) {
                    $fileField.trigger('click');
                }*/
            });

            $fileField.on('change', function() {
                $notifications.html('');

                let fileFieldFilename = $fileField.val(),
                    buttonText = $uploadButton.data('text-default');
                if (fileFieldFilename !== '') {
                    // fileFieldFilename = fileFieldFilename.replace(/^.*[\\\/]/, '');
                    // $uploadFilename.text(fileFieldFilename);
                    $uploadSection.hide();
                    $formSection.show();

                    /*$uploadButton.html('<i class="fa fa-refresh fa-spin"></i> &nbsp;' + $uploadButton.data('text-uploading')).addClass('evc-custom-maps__upload__button--uploading');

                    $.ajax({
                        url: '/dashboard/EvcCustomMapForm/',
                        type: 'POST',
                        data: new FormData($customMapsForm[0]), // The form with the file inputs.
                        cache: false,
                        contentType: false,
                        processData: false,
                        dataType: 'json',
                        success: function (data) {
                            let buttonText = $uploadButton.data('text-default');
                            if (!$.isArray(data) && data.status === 1) {
                                $uploadFilename.text(fileFieldFilename);
                                $info.hide();
                                $description.show();
                                buttonText = $uploadButton.data('text-submit');
                                $uploadButton.addClass('evc-custom-maps__upload__button--submit');
                                $uploadButton.data('file-id', data.customMapFileID);
                            } else {
                                $fileField.val('');
                                $uploadFilename.text('');
                                $info.show();
                                $description.hide();
                            }

                            $uploadButton.text(buttonText).removeClass('evc-custom-maps__upload__button--uploading');

                            let messagesHTML = '';
                            if ($.isArray(data) && 'message' in data[0]) { // Upload error
                               messagesHTML = messagesHtmlGenerate([{ type: 'danger', text: data[0].message }], 'bootstrapAlert');
                            } else if ('messages' in data && data.messages) {
                                messagesHTML = messagesHtmlGenerate(data.messages, 'bootstrapAlert');
                            }

                            if (messagesHTML.length) {
                                $notifications.html(messagesHTML);
                            }
                        },
                        error: function () {
                            $fileField.val('');
                            $uploadFilename.text('');
                            $info.show();
                            $description.hide();
                            $uploadButton.text($uploadButton.data('text-default')).removeClass('evc-custom-maps__upload__button--uploading');

                            let messagesHtml = messagesHtmlGenerate([{type: 'danger', text: 'An error occured. Please reload the page.'}]);
                            $notifications.html(messagesHtml);
                        },
                    });*/
                }
            });

            $customMapsForm.parsley().on('form:submit', function() {
                $formSubmitButton.hide();
                $formUploading.show();

                $.ajax({
                    url: '/dashboard/EvcCustomMapForm/',
                    type: 'POST',
                    data: new FormData($customMapsForm[0]), // The form with the file inputs.
                    cache: false,
                    contentType: false,
                    processData: false,
                    dataType: 'json',
                    success: function (data) {

                        if (!$.isArray(data) && data.status === 1) {
                            $uploadSection.show();
                            $formSection.hide();

                            let messagesHTML = messagesHtmlGenerate([{ type: 'success', text: 'SUBMISSION SUCCESSFUL' }], 'bootstrapAlert');
                            if (messagesHTML.length) {
                                $notifications.html(messagesHTML);
                            }
                        }

                        $formSubmitButton.show();
                        $formUploading.hide();

                        let messagesHTML = '';
                        if ($.isArray(data) && 'message' in data[0]) { // Upload error
                            for (let n = 0, m = data.length; n < m; n++) {
                                if ('message' in data[n]) {
                                    messagesHTML += messagesHtmlGenerate([{ type: 'danger', text: data[n].message }], 'bootstrapAlert');
                                }
                            }
                        } else if ('messages' in data && data.messages) {
                            messagesHTML = messagesHtmlGenerate(data.messages, 'bootstrapAlert');
                        }

                        if (messagesHTML.length) {
                            $notifications.html(messagesHTML);
                        }

                        $evcCustomMapsWrapper.get(0).scrollIntoView({ behavior: 'smooth' });
                    },
                    error: function () {
                        $formSubmitButton.show();
                        $formUploading.hide();

                        let messagesHtml = messagesHtmlGenerate([{type: 'danger', text: 'An error occured. Please reload the page.'}]);
                        $notifications.html(messagesHtml);
                    },
                });

                return false;
            });

        }
    }



});



// WEBPACK FOOTER //
// ./js/modules/evc.js